import { render, staticRenderFns } from "./FilterTermSelect.vue?vue&type=template&id=64c454ec&scoped=true&"
import script from "./FilterTermSelect.vue?vue&type=script&lang=js&"
export * from "./FilterTermSelect.vue?vue&type=script&lang=js&"
import style0 from "./FilterTermSelect.vue?vue&type=style&index=0&id=64c454ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c454ec",
  null
  
)

export default component.exports